import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  fetch(portId) {
    return http.get(`${resource}/${portId}/vehicles`);
  },

  update(portId, itemId, payload) {
    return http.put(`${resource}/${portId}/vehicles/${itemId}`, payload);
  },

  updateOrders(portId, payload) {
    return http.put(`${resource}/${portId}/vehicles/sorts`, payload);
  },

  add(portId, payload) {
    return http.post(`${resource}/${portId}/vehicles`, payload);
  },

  delete(portId, itemId) {
    return http.delete(`${resource}/${portId}/vehicles/${itemId}`);
  },
};
